/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Source_Target_Match_ErrorInputs */

const en_source_target_match_error = /** @type {(inputs: Source_Target_Match_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Source and target event groups match. Nothing to copy.`)
};

const fr_source_target_match_error = /** @type {(inputs: Source_Target_Match_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les groupes source et cible sont identiques. Rien à copier.`)
};

const de_source_target_match_error = /** @type {(inputs: Source_Target_Match_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quell- und Zielereignisgruppen stimmen überein. Es muss nichts kopiert werden.`)
};

const it_source_target_match_error = /** @type {(inputs: Source_Target_Match_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I gruppi di eventi di origine e destinazione corrispondono. Niente da copiare.`)
};

const ru_source_target_match_error = /** @type {(inputs: Source_Target_Match_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Исходная и целевая группы событий совпадают. Копировать нечего.`)
};

const es_source_target_match_error = /** @type {(inputs: Source_Target_Match_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los grupos de eventos de origen y destino coinciden. No hay nada que copiar.`)
};

const zh_cn2_source_target_match_error = /** @type {(inputs: Source_Target_Match_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`源事件组和目标事件组匹配。无需复制任何内容。`)
};

const ja_source_target_match_error = /** @type {(inputs: Source_Target_Match_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ソースとターゲットのイベント グループが一致しています。コピーするものはありません。`)
};

const hi_source_target_match_error = /** @type {(inputs: Source_Target_Match_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्रोत और लक्ष्य इवेंट समूह मेल खाते हैं। कॉपी करने के लिए कुछ भी नहीं है।`)
};

const pt_pt2_source_target_match_error = /** @type {(inputs: Source_Target_Match_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os grupos de eventos de origem e destino correspondem. Nada a copiar.`)
};

/**
* | output |
* | --- |
* | "Source and target event groups match. Nothing to copy." |
*
* @param {Source_Target_Match_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const source_target_match_error = /** @type {((inputs?: Source_Target_Match_ErrorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Source_Target_Match_ErrorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_source_target_match_error(inputs)
	if (locale === "de") return de_source_target_match_error(inputs)
	if (locale === "it") return it_source_target_match_error(inputs)
	if (locale === "ru") return ru_source_target_match_error(inputs)
	if (locale === "es") return es_source_target_match_error(inputs)
	if (locale === "zh-CN") return zh_cn2_source_target_match_error(inputs)
	if (locale === "ja") return ja_source_target_match_error(inputs)
	if (locale === "hi") return hi_source_target_match_error(inputs)
	if (locale === "pt-PT") return pt_pt2_source_target_match_error(inputs)
	return en_source_target_match_error(inputs)
});